import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { Subscription, forkJoin } from "rxjs";
import { finalize } from 'rxjs/operators';
import { EmitterService } from "src/app/EmitterService";
import { AppService } from "src/app/app.service";

@Component({
  selector: "app-notice",
  templateUrl: "./notice.component.html",
  styleUrls: ["./notice.component.scss"],
})
export class NoticeComponent implements OnInit {
  Notices = [];
  subscription: Subscription;
  loading = true;
  urlSafe: SafeResourceUrl;
  find_category: any;

  selectedNotice: any;
  notice_cat_values: any[];
  filteredNotices: any[] = [];
  selectedCategory: string = "Search Notices";

  constructor(
    private emitterService: EmitterService,
    public sanitizer: DomSanitizer,
    private appService: AppService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadNotices();
  }

  loadNotices() {
    this.loading = true;
    
    forkJoin([
      this.appService.getNotices()
    ]).pipe(
      finalize(() => this.loading = false)
    ).subscribe({
      next: (response: any) => {
        // First filter only active notices
        this.Notices = (response[0].data || [])
          .filter(notice => 
            notice.IsActive === true || 
            notice.Status === 'Active'
          );
        
        // Then sort the active notices by Id (newest first)
        this.Notices.sort((a, b) => b.Id - a.Id);
        
        // Collect categories from active notices only
        this.notice_cat_values = [...new Set(
          this.Notices.map(x => x.NoticeCategoryName)
        )];
        
        // Set filtered notices (all active notices initially)
        this.filteredNotices = [...this.Notices];
        
        // Update view
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Error loading notices:', err);
        // Handle error (could show toast/message)
      }
    });
  }

  onSelectCategory(category: string): void {
    this.selectedCategory = category;
    this.filteredNotices = category === "All Notices"
      ? [...this.Notices] // Return copy of all active notices
      : this.Notices.filter(notice => notice.NoticeCategoryName === category);
  }

  onSearch(): void {
    this.filteredNotices = this.selectedCategory
      ? this.Notices.filter(notice => notice.NoticeCategoryName === this.selectedCategory)
      : [...this.Notices]; // Return copy of all active notices
  }

  showNotice(event: Event, notice: any) {
    event.preventDefault();
    this.selectedNotice = notice;
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.selectedNotice.FileLink.includes("https://") 
        ? this.selectedNotice.FileLink 
        : `https://${this.selectedNotice.FileLink}`
    );
  }

  isImage(link: string): boolean {
    return /\.(jpe?g|png|gif)$/i.test(link);
  }

  TransformUrl(value: string) {
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
      value.includes("https://") ? value : `https://${value}`
    );
    return this.urlSafe;
  }

  onNoticeUploadSuccess() {
    this.loadNotices();
  }
}